import { Color } from '@tmh-website/shared/colors';
import StyledTypo from '@tmh-website/styles/typo';
import ButtonIcon from '@tmh-website/ui/ButtonIcon';
import { CaretRight } from '@phosphor-icons/react';
import styled, { css } from 'styled-components';

export const IconWrapper = styled(ButtonIcon)<{ $isOpen: boolean }>`
  width: 38px;
  height: 38px;
  margin-left: auto;
  @media (${props => props.theme.breakpoint.md.up}) {
    margin-top: 2px;
    background-color: transparent !important;
  }
`;

export const ChevronIcon = styled(CaretRight)`
  transition: transform ${props => props.theme.transitionTiming};
  transform: translateX(0);
`;

export const Label = styled.span`
  padding: 10px;
  margin: 0 -10px;
`;

export const Container = styled.div<{ $isSelected?: boolean; $isOpen?: boolean }>`
  ${StyledTypo.h5Css};
  z-index: 3;
  display: flex;
  align-items: center;
  padding: 0 ${props => props.theme.wrapperPaddingMobile};
  margin: 10px 0 0;
  color: ${props => props.theme.color[Color.Neutral_0_White]};
  cursor: pointer;
  opacity: ${props => (props.$isSelected ? 1 : 0.6)};
  transition: opacity ${props => props.theme.transitionTiming};
  ${props =>
    props.$isSelected &&
    css`
      color: ${props => props.theme.color[Color.Blue_500_Ultramarine]};
    `};
  @media (${props => props.theme.breakpoint.md.up}) {
    padding: 0;
  }

  &:first-child {
    margin: 0;
  }

  &:hover {
    text-decoration: none;
    opacity: 1;

    ${ChevronIcon} {
      @media (${props => props.theme.breakpoint.md.up}) {
        transform: translateX(10px);
      }
    }
  }

  ${ChevronIcon} {
    @media (${props => props.theme.breakpoint.md.down}) {
      ${props =>
        props.$isOpen &&
        css`
          transform: rotate(90deg);
        `}
    }
    @media (${props => props.theme.breakpoint.md.up}) {
      ${props =>
        props.$isOpen &&
        css`
          transform: translateX(10px);
        `}
    }
    ${props =>
      props.$isSelected &&
      css`
        color: ${props => props.theme.color[Color.Blue_500_Ultramarine]};
      `}
  }
`;
